var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __read = (this && this.__read) || function (o, n) {
    var m = typeof Symbol === "function" && o[Symbol.iterator];
    if (!m) return o;
    var i = m.call(o), r, ar = [], e;
    try {
        while ((n === void 0 || n-- > 0) && !(r = i.next()).done) ar.push(r.value);
    }
    catch (error) { e = { error: error }; }
    finally {
        try {
            if (r && !r.done && (m = i["return"])) m.call(i);
        }
        finally { if (e) throw e.error; }
    }
    return ar;
};
var __spreadArray = (this && this.__spreadArray) || function (to, from, pack) {
    if (pack || arguments.length === 2) for (var i = 0, l = from.length, ar; i < l; i++) {
        if (ar || !(i in from)) {
            if (!ar) ar = Array.prototype.slice.call(from, 0, i);
            ar[i] = from[i];
        }
    }
    return to.concat(ar || Array.prototype.slice.call(from));
};
var __values = (this && this.__values) || function(o) {
    var s = typeof Symbol === "function" && Symbol.iterator, m = s && o[s], i = 0;
    if (m) return m.call(o);
    if (o && typeof o.length === "number") return {
        next: function () {
            if (o && i >= o.length) o = void 0;
            return { value: o && o[i++], done: !o };
        }
    };
    throw new TypeError(s ? "Object is not iterable." : "Symbol.iterator is not defined.");
};
var Gt = Object.defineProperty;
var Ft = function (e, t, s) { return t in e ? Gt(e, t, { enumerable: !0, configurable: !0, writable: !0, value: s }) : e[t] = s; };
var Y = function (e, t, s) { return (Ft(e, typeof t != "symbol" ? t + "" : t, s), s); }, Pt = function (e, t, s) {
    if (!t.has(e))
        throw TypeError("Cannot " + s);
};
var S = function (e, t, s) {
    if (t.has(e))
        throw TypeError("Cannot add the same private member more than once");
    t instanceof WeakSet ? t.add(e) : t.set(e, s);
};
var b = function (e, t, s) { return (Pt(e, t, "access private method"), s); };
var yt = function (e) {
    if (!e || typeof e != "object")
        return !1;
    var t = Object.getPrototypeOf(e);
    return t === Object.prototype || t === null;
}, vt = function (e) { return typeof e == "function"; }, W = function (e) { return !isNaN(Number(e)); }, rt = function (e) { return e == null; }, lt = function (e) { return e instanceof HTMLElement ? e : document.querySelector(e); }, ct = function (e, t) { return t ? e.closest(".".concat(t)) : null; }, R = function (e) { return "touches" in e ? e.touches.length === 0 ? { clientX: 0, clientY: 0 } : e.touches.length === 1 ? { clientX: e.touches[0].clientX, clientY: e.touches[0].clientY } : {
    clientX: __spreadArray([], __read(e.touches), false).reduce(function (t, s) { return t + s.clientX; }, 0) / e.touches.length,
    clientY: __spreadArray([], __read(e.touches), false).reduce(function (t, s) { return t + s.clientY; }, 0) / e.touches.length
} : { clientX: e.clientX, clientY: e.clientY }; }, y = function (e) {
    var _a = e.getBoundingClientRect(), t = _a.width, s = _a.height, n = _a.top, o = _a.left, r = _a.bottom;
    return {
        width: t,
        height: s,
        top: n,
        left: o,
        bottom: r
    };
}, Et = function (e) { return e.touches.length >= 2 ? Math.hypot(e.touches[0].clientX - e.touches[1].clientX, e.touches[0].clientY - e.touches[1].clientY) : 0; }, C = function (e, t) {
    var e_1, _a;
    try {
        for (var _b = __values(Object.entries(t)), _c = _b.next(); !_c.done; _c = _b.next()) {
            var _d = __read(_c.value, 2), s = _d[0], n = _d[1];
            typeof n == "string" && e.style.setProperty(s, n);
        }
    }
    catch (e_1_1) { e_1 = { error: e_1_1 }; }
    finally {
        try {
            if (_c && !_c.done && (_a = _b.return)) _a.call(_b);
        }
        finally { if (e_1) throw e_1.error; }
    }
}, x = function (e, t) {
    var e_2, _a;
    try {
        for (var _b = __values(Object.entries(t)), _c = _b.next(); !_c.done; _c = _b.next()) {
            var _d = __read(_c.value, 2), s = _d[0], n = _d[1];
            e.setAttribute(s, n);
        }
    }
    catch (e_2_1) { e_2 = { error: e_2_1 }; }
    finally {
        try {
            if (_c && !_c.done && (_a = _b.return)) _a.call(_b);
        }
        finally { if (e_2) throw e_2.error; }
    }
}, E = function (e, t) {
    var e_3, _a;
    try {
        for (var _b = __values(Object.entries(t)), _c = _b.next(); !_c.done; _c = _b.next()) {
            var _d = __read(_c.value, 2), s = _d[0], n = _d[1];
            e[s] = n;
        }
    }
    catch (e_3_1) { e_3 = { error: e_3_1 }; }
    finally {
        try {
            if (_c && !_c.done && (_a = _b.return)) _a.call(_b);
        }
        finally { if (e_3) throw e_3.error; }
    }
}, w = function (e, t, s) { return Math.min(Math.max(e, t), s); }, X = function (e) { return isNaN(e) ? 0 : Math.round(e * 100) / 100; }, St = function (e) {
    throw new Error(e);
}, ht = function (e) { return console.warn(e); }, I = function (e, t, s, n) {
    var _a;
    if (e === void 0) { e = "div"; }
    var o = document.createElement(e);
    return t && (_a = o.classList).add.apply(_a, __spreadArray([], __read(t.split(" ")), false)), s && x(o, s), n && (o.innerHTML = n), o;
}, p = "zoomist", qt = "".concat(p, "-container"), bt = "".concat(p, "-wrapper"), ut = "".concat(p, "-image"), Kt = "".concat(p, "-not-draggable"), Jt = "".concat(p, "-not-wheelable"), $ = "".concat(p, "-slider"), Qt = "".concat(p, "-slider-wrapper"), te = "".concat(p, "-slider-bar"), ee = "".concat(p, "-slider-button"), Z = "".concat(p, "-zoomer"), se = "".concat(p, "-zoomer-button"), gt = "".concat(p, "-zoomer-icon"), mt = "".concat(p, "-zoomer-in"), dt = "".concat(p, "-zoomer-out"), ft = "".concat(p, "-zoomer-reset"), ne = "".concat(p, "-zoomer-disabled"), ie = {
    tabindex: "0",
    role: "slider",
    "aria-label": "slider for zoomist",
    "aria-valuemin": "0",
    "aria-valuemax": "100",
    "aria-valuenow": "0",
    "aria-disabled": "false"
}, _t = {
    tabindex: "0",
    role: "button",
    type: "button",
    "aria-disabled": "false"
}, oe = __assign(__assign({}, _t), { "aria-label": "button for zoom in zoomist" }), ae = __assign(__assign({}, _t), { "aria-label": "button for zoom out zoomist" }), re = __assign(__assign({}, _t), { "aria-label": "button for reset zoomist scale" }), le = typeof window < "u" && typeof window.document < "u", L = le && "ontouchstart" in window, ce = L ? "touchstart" : "mousedown", Tt = L ? "touchmove" : "mousemove", Ot = L ? "touchend" : "mouseup", he = "wheel", ue = ["left", "right", "center"], me = ["top", "bottom", "center"], Yt = "--scale", Xt = "--translate-x", Dt = "--translate-y", de = "--value", wt = {
    // set is draggable or not
    draggable: !0,
    // set is wheelable or not
    wheelable: !0,
    // set is pinchable or not
    pinchable: !0,
    // set image stuck on bounds
    bounds: !0,
    // the ratio of zooming at one time
    zoomRatio: 0.1,
    // the max scale of zoomist-image (must be number larger then initScale)
    maxScale: 10,
    // the min scale of zoomist-image (must be number smaller then initScale)
    minScale: 1,
    // set initial scale of zoomist-image
    initScale: null,
    // if set to true, enable to release touch events to allow for further page scrolling when .zoomist-image is on bounds.
    dragReleaseOnBounds: !1,
    // if set to true, enable to release wheel events to allow for further page scrolling when .zoomist-image is on mixScale or maxScale.
    wheelReleaseOnMinMax: !1,
    // elements matched this class will not be dragged.
    disableDraggingClass: Kt,
    // elements matched this class will not be zoomed by mouse wheel.
    disableWheelingClass: Jt,
    // if set to true, enable to smooth drag
    smooth: !1
}, fe = {
    // the css selector string or a element of the slider
    el: null,
    // the direction of the slider 'horizontal' or 'vertical'
    direction: "horizontal"
}, ge = {
    el: ".".concat($)
}, _e = {
    el: null,
    // the css selector string or a element for in-zoomer
    inEl: null,
    // the css selector string or a element for out-zoomer
    outEl: null,
    // the css selector string or a element for reset-zoomer
    resetEl: null,
    // in zoomer and out zoomer will be disabled when image comes to maximin or minimum
    disabledClass: ne
}, pe = {
    el: ".".concat(Z),
    inEl: ".".concat(mt),
    outEl: ".".concat(dt),
    resetEl: ".".concat(ft)
}, ve = {
    // invoked when zoomist instance ready
    ready: null,
    // invoked when reset methods be used
    reset: null,
    // invoked when image changes it's size
    resize: null,
    // invoked before destroy methods be used
    beforeDestroy: null,
    // invoked after destroy methods be used
    destroy: null,
    // invoked before update methods be used
    beforeUpdate: null,
    // invoked when update methods be used
    update: null,
    // invoked when image is zooming
    zoom: null,
    // invoked when wheeling
    wheel: null,
    // invoked when mousedown on wrapper
    dragStart: null,
    // invoked when dragging the image
    drag: null,
    // invoked when mouseup on wrapper
    dragEnd: null,
    // invoked when mousedown on wrapper
    pinchStart: null,
    // invoked when pinching the image
    pinch: null,
    // invoked when mouseup on wrapper
    pinchEnd: null,
    // invoked when mousedown on slider
    slideStart: null,
    // invoked when sliding the slider
    slide: null,
    // invoked when mouseup on slider
    slideEnd: null
}, Ee = {
    // slider options
    slider: null,
    // zoomer options
    zoomer: null
}, Se = "\n<svg viewBox=\"0 0 12 12\" class=\"".concat(gt, "\">\n  <polygon points=\"12,5.5 6.5,5.5 6.5,0 5.5,0 5.5,5.5 0,5.5 0,6.5 5.5,6.5 5.5,12 6.5,12 6.5,6.5 12,6.5 \"/>\n</svg>\n"), be = "\n<svg viewBox=\"0 0 12 12\" class=\"".concat(gt, "\">\n  <rect y=\"5.5\" width=\"12\" height=\"1\"/>\n</svg>\n"), Te = "\n<svg viewBox=\"0 0 12 12\" class=\"".concat(gt, "\">\n  <path d=\"m7.45,1.27l.35-.22c.26-.17.34-.52.17-.78-.17-.27-.52-.34-.78-.17l-1.54.99-.19.13-.11.46,1.12,1.75c.11.17.29.26.48.26.1,0,.21-.03.31-.09.26-.17.34-.52.17-.78l-.29-.46c1.85.5,3.22,2.17,3.22,4.18,0,2.39-1.95,4.34-4.34,4.34S1.66,8.92,1.66,6.52c0-1.15.44-2.23,1.25-3.05.22-.22.22-.58,0-.8-.22-.22-.58-.22-.8,0-1.02,1.03-1.58,2.4-1.58,3.85,0,3.02,2.46,5.48,5.48,5.48s5.48-2.46,5.48-5.48c0-2.51-1.71-4.62-4.02-5.26Z\"/>\n</svg>\n"), Oe = {
    on: function (e, t) {
        if (!t || !vt(t))
            return this;
        var s = this.__events__;
        return e.split(" ").forEach(function (n) {
            var o = n;
            s[o] || (s[o] = []), s[o].push(t);
        }), this;
    },
    emit: function (e) {
        var _this = this;
        var t = [];
        for (var _i = 1; _i < arguments.length; _i++) {
            t[_i - 1] = arguments[_i];
        }
        var s = this.__events__;
        return s[e] ? (s[e].forEach(function (n) {
            vt(n) && n.apply(_this, t);
        }), this) : this;
    },
    zoom: function (e, t) {
        var s = this.transform.scale, n = this.useFixedRatio(X(s * (e + 1)));
        return s === n ? this : (this.zoomTo(n, t), this);
    },
    zoomTo: function (e, t) {
        if (t === void 0) { t = !0; }
        var _a = this, s = _a.image, _b = _a.transform, n = _b.scale, o = _b.translateX, r = _b.translateY, i = _a.options.bounds;
        if (e = this.useFixedRatio(e), e === n)
            return this;
        if (this.transform.scale = e, !t)
            return this.emit("zoom", this, this.transform.scale), this;
        t = typeof t == "boolean" ? this.getContainerCenterClient() : t;
        var l = t.clientX, h = t.clientY, _c = y(s), c = _c.top, f = _c.left, m = _c.width, a = _c.height, _d = this.getImageDiff(), d = _d.width, g = _d.height, _ = e / n - 1, T = (m / 2 - l + f) * _ + o, u = (a / 2 - h + c) * _ + r, v = i ? w(T, d, -d) : T, O = i ? w(u, g, -g) : u;
        return E(this.transform, {
            translateX: v,
            translateY: O
        }), this.emit("zoom", this, this.transform.scale), this;
    },
    move: function (e) {
        var _a = this, t = _a.options.bounds, _b = _a.transform, s = _b.translateX, n = _b.translateY, o = e.x, r = e.y, _c = this.getImageDiff(), i = _c.width, l = _c.height;
        if (W(o)) {
            var h = s + o, c = t ? w(h, i, -i) : h;
            this.transform.translateX = c;
        }
        if (W(r)) {
            var h = n + r, c = t ? w(h, l, -l) : h;
            this.transform.translateY = c;
        }
        return this;
    },
    moveTo: function (e) {
        var t = this.options.bounds, s = e.x, n = e.y, _a = this.getImageDiff(), o = _a.width, r = _a.height;
        if (W(s)) {
            var i = Number(s), l = t ? w(i, o, -o) : i;
            this.transform.translateX = l;
        }
        if (W(n)) {
            var i = Number(n), l = t ? w(i, r, -r) : i;
            this.transform.translateY = l;
        }
        if (ue.some(function (i) { return i === s; })) {
            var l = {
                left: -o,
                right: o,
                center: 0
            }[s];
            this.transform.translateX = l;
        }
        if (me.some(function (i) { return i === n; })) {
            var l = {
                top: -r,
                bottom: r,
                center: 0
            }[n];
            this.transform.translateY = l;
        }
        return this;
    },
    slideTo: function (e) {
        var _a = this.options, t = _a.minScale, s = _a.maxScale, n = (s - t) * e / 100 + t;
        return this.zoomTo(n), this;
    },
    reset: function () {
        var e = this.options.initScale;
        return E(this.transform, {
            scale: e,
            translateX: 0,
            translateY: 0
        }), this.emit("reset", this), this;
    },
    destroy: function (e) {
        if (e === void 0) { e = !1; }
        var _a = this, t = _a.element, s = _a.image, n = _a.controller;
        return this.mounted && (this.emit("beforeDestroy", this), n.abort(), this.destroyModules(), e && s && (this.reset(), s.removeAttribute("style")), t[p] = null, this.mounted = !1, this.emit("destroy", this)), null;
    },
    update: function (e) {
        var _a = this, t = _a.element, s = _a.controller;
        return this.emit("beforeUpdate", this), t[p] = null, this.mounted = !1, s.abort(), this.destroyModules(), e && (this.options = Object.assign({}, wt, yt(e) && e)), this.init(), this.emit("update", this), this;
    },
    getImageData: function () {
        return __assign({}, this.data.imageData);
    },
    getContainerData: function () {
        return __assign({}, this.data.containerData);
    },
    getSliderValue: function () {
        var e = this.__modules__.slider;
        return e && e.value !== void 0 ? e.value : null;
    },
    isOnBoundTop: function () {
        var e = this.options.bounds;
        if (!e)
            return !1;
        var t = this.transform.translateY, s = this.getImageDiff().height;
        return t * -1 === X(s);
    },
    isOnBoundBottom: function () {
        var e = this.options.bounds;
        if (!e)
            return !1;
        var t = this.transform.translateY, s = this.getImageDiff().height;
        return t === X(s);
    },
    isOnBoundLeft: function () {
        var e = this.options.bounds;
        if (!e)
            return !1;
        var t = this.transform.translateX, s = this.getImageDiff().width;
        return t * -1 === X(s);
    },
    isOnBoundRight: function () {
        var e = this.options.bounds;
        if (!e)
            return !1;
        var t = this.transform.translateX, s = this.getImageDiff().width;
        return t === X(s);
    },
    isOnBoundX: function () {
        var e = this.options.bounds;
        if (!e)
            return !1;
        var t = this.transform.translateX, s = this.getImageDiff().width;
        return Math.abs(t) === Math.abs(X(s));
    },
    isOnBoundY: function () {
        var e = this.options.bounds;
        if (!e)
            return !1;
        var t = this.transform.translateY, s = this.getImageDiff().height;
        return Math.abs(t) === Math.abs(X(s));
    },
    isOnMinScale: function () {
        var e = this.options.minScale, t = this.transform.scale;
        return t === e;
    },
    isOnMaxScale: function () {
        var e = this.options.maxScale, t = this.transform.scale;
        return t === e;
    },
    // private methods
    getImageDiff: function () {
        var _a = this.getContainerData(), e = _a.width, t = _a.height, _b = this.getImageData(), s = _b.width, n = _b.height;
        return {
            width: (e - s) / 2,
            height: (t - n) / 2
        };
    },
    // private methods
    getContainerCenterClient: function () {
        var e = this.element, _a = y(e), t = _a.top, s = _a.left, n = _a.width, o = _a.height;
        return {
            clientX: s + n / 2,
            clientY: t + o / 2
        };
    },
    // private methods
    getScaleRatio: function () {
        var _a = this, e = _a.transform.scale, _b = _a.options, t = _b.minScale, s = _b.maxScale;
        return (e - t) / (s - t);
    },
    // private methods
    useFixedRatio: function (e) {
        var _a = this.options, t = _a.minScale, s = _a.maxScale;
        return w(e, t, s);
    },
    // private methods
    // animation
    useAnimate: function (e) {
        var _this = this;
        var _a = this, t = _a.options.smooth, s = _a.transform, o = (1100 - (typeof t == "object" ? Math.max(0.1, Math.min(1, t.damping)) : 0.6) * 1e3) * 0.5, r = function () {
            if (!_this.states.dragging && (Math.abs(e.velocityX) > 0.01 || Math.abs(e.velocityY) > 0.01)) {
                var i = Date.now(), l = i - e.lastTime, h = Math.exp(-l / o);
                e.velocityX *= h, e.velocityY *= h, e.lastTime = i;
                var c = e.velocityX * l, f = e.velocityY * l;
                if (_this.moveTo({
                    x: s.translateX + c,
                    y: s.translateY + f
                }), Math.abs(e.velocityX) < 0.01 && Math.abs(e.velocityY) < 0.01) {
                    e.frame = null;
                    return;
                }
            }
            e.frame = requestAnimationFrame(r);
        };
        return r;
    }
}, H = Object.defineProperty;
var V, Rt, U, At, j, Lt, k, zt, G, Mt, F, Ct, P, It, q, xt, K, $t, J, Nt, Q, Bt, tt, Wt;
var Ye = /** @class */ (function () {
    function Ye(t, s) {
        // create initial data
        S(this, V);
        // mount elements and bind events
        S(this, U);
        // resize, drag, pinch, wheel
        S(this, j);
        // on wheel
        S(this, k);
        // on drag (mouse)
        S(this, G);
        // on touch (pinch and touchmove)
        S(this, F);
        // resize observer on element
        S(this, P);
        // check modules and create
        S(this, q);
        // mount slider
        S(this, K);
        // slider events
        S(this, J);
        // mount zoomer
        S(this, Q);
        // zoomer event
        S(this, tt);
        Y(this, "element");
        Y(this, "options");
        Y(this, "wrapper");
        Y(this, "image");
        Y(this, "mounted");
        Y(this, "data");
        Y(this, "transform");
        Y(this, "states");
        Y(this, "controller");
        Y(this, "__events__");
        Y(this, "__modules__");
        if (!t)
            return St("The first argument is required.");
        var n = lt(t);
        if (!n)
            return St("Element ".concat(t, " is not exist."));
        this.element = n, this.options = Object.assign({}, wt, yt(s) && s), this.init();
    }
    // check zoomist-image is exist
    Ye.prototype.init = function () {
        var t = this.element, _a = this.options, s = _a.bounds, n = _a.minScale, o = _a.maxScale, r = _a.initScale;
        if (t[p])
            return;
        t[p] = this;
        var i = t.querySelector(".".concat(bt)), l = t.querySelector(".".concat(ut));
        if (!i)
            return ht("".concat(p, " needs a \".").concat(bt, "\" element."));
        if (!l)
            return ht("".concat(p, " needs a \".").concat(ut, "\" element."));
        this.options.minScale = s && n < 1 ? 1 : n, this.options.maxScale = Math.max(o, n), this.options.initScale = w(r || n, n, o), this.wrapper = i, this.image = l, b(this, V, Rt).call(this);
    };
    // destory modules
    Ye.prototype.destroyModules = function () {
        var _a = this.__modules__, t = _a.slider, s = _a.zoomer;
        t && this.destroySlider(), s && this.destroyZoomer();
    };
    // destroy slider
    Ye.prototype.destroySlider = function () {
        var r, i;
        var t = this.__modules__.slider;
        if (!t || !t.mounted)
            return;
        var s = t.options.el, n = t.controller;
        s === ".".concat($) ? (r = t.sliderEl) == null || r.remove() : (i = t.sliderTrack) == null || i.remove(), n == null || n.abort(), t.mounted = !1;
    };
    // destroy zoomer
    Ye.prototype.destroyZoomer = function () {
        var t = this.__modules__.zoomer;
        if (!t || !t.mounted)
            return;
        var _a = t.options, s = _a.el, n = _a.inEl, o = _a.outEl, r = _a.resetEl, i = t.controller, l = t.zoomerEl, h = t.zoomerInEl, c = t.zoomerOutEl, f = t.zoomerResetEl, m = function (a, d, g) {
            a === ".".concat(d) && (g == null || g.remove());
        };
        [
            { target: s, className: Z, el: l },
            { target: n, className: mt, el: h },
            { target: o, className: dt, el: c },
            { target: r, className: ft, el: f }
        ].forEach(function (a) { return m(a.target, a.className, a.el); }), i == null || i.abort(), t.mounted = !1;
    };
    return Ye;
}());
V = new WeakSet(), Rt = function () {
    var e_4, _a;
    var _b = this, t = _b.element, s = _b.image, n = _b.options, o = n.draggable, r = n.pinchable, i = t.offsetWidth, l = t.offsetHeight, h = s.offsetWidth, c = s.offsetHeight, _c = y(s), f = _c.width, m = _c.height;
    if (!h || !c)
        return ht("The width or height of ".concat(ut, " should not be 0."));
    if (this.transform = {
        scale: 0,
        translateX: 0,
        translateY: 0
    }, this.data = {
        imageData: {
            originWidth: h,
            originHeight: c,
            width: f,
            height: m
        },
        containerData: {
            width: i,
            height: l
        }
    }, L && (o || r) && (this.data.touchData = {
        hypot: 0,
        prevX: 0,
        prevY: 0,
        offsetX: 0,
        offsetY: 0,
        imageTop: 0,
        imageLeft: 0,
        widthDiff: 0,
        heightDiff: 0,
        lastTime: 0,
        velocityX: 0,
        velocityY: 0,
        frame: null
    }), !L && o && (this.data.dragData = {
        prevX: 0,
        prevY: 0,
        lastTime: 0,
        velocityX: 0,
        velocityY: 0,
        frame: null
    }), this.__events__ = __assign({}, ve), n.on)
        try {
            for (var _d = __values(Object.entries(n.on)), _f = _d.next(); !_f.done; _f = _d.next()) {
                var _g = __read(_f.value, 2), a = _g[0], d = _g[1];
                this.__events__[a] = [d];
            }
        }
        catch (e_4_1) { e_4 = { error: e_4_1 }; }
        finally {
            try {
                if (_f && !_f.done && (_a = _d.return)) _a.call(_d);
            }
            finally { if (e_4) throw e_4.error; }
        }
    if (this.__modules__ = __assign({}, Ee), n.slider) {
        var a = n.slider === !0 ? ge : n.slider;
        this.__modules__.slider = {
            options: Object.assign({}, fe, a)
        };
    }
    if (n.zoomer) {
        var a = n.zoomer === !0 ? pe : n.zoomer;
        this.__modules__.zoomer = {
            options: Object.assign({}, _e, a)
        };
    }
    this.controller = new AbortController(), b(this, U, At).call(this);
}, U = new WeakSet(), At = function () {
    var _this = this;
    if (this.mounted)
        return;
    var _a = this, t = _a.element, s = _a.image, _b = _a.options, n = _b.minScale, o = _b.maxScale, r = _b.initScale, _c = _a.__modules__, i = _c.slider, l = _c.zoomer;
    C(s, {
        transform: "\n        translate(var(".concat(Xt, ", 0px), var(").concat(Dt, ", 0px))\n        scale(var(").concat(Yt, ", 0))")
    }), H(this.transform, "scale", {
        get: function () { return _this.transform.__scale__; },
        set: function (h) {
            var _a;
            var c = _this.useFixedRatio(h);
            if (!(rt(c) || _this.transform.__scale__ === c)) {
                if (_this.transform.__scale__ = c, C(s, (_a = {}, _a[Yt] = c.toString(), _a)), E(_this.data.imageData, {
                    width: y(s).width,
                    height: y(s).height
                }), i) {
                    var f = Math.round(_this.getScaleRatio() * 100);
                    i.value = f;
                }
                if (l && l.options.disabledClass) {
                    var f = l.zoomerInEl, m = l.zoomerOutEl, a = l.zoomerResetEl, d = l.options.disabledClass;
                    f && (f.classList[c === o ? "add" : "remove"](d), x(f, { "aria-disabled": c === o ? "true" : "false" })), m && (m.classList[c === n ? "add" : "remove"](d), x(m, { "aria-disabled": c === n ? "true" : "false" })), a && (a.classList[c === r ? "add" : "remove"](d), x(a, { "aria-disabled": c === r ? "true" : "false" }));
                }
            }
        }
    }), H(this.transform, "translateX", {
        get: function () { return _this.transform.__translateX__; },
        set: function (h) {
            var _a;
            var c = X(h);
            rt(c) || _this.transform.__translateX__ === c || (_this.transform.__translateX__ = c, C(s, (_a = {}, _a[Xt] = "".concat(c, "px"), _a)));
        }
    }), H(this.transform, "translateY", {
        get: function () { return _this.transform.__translateY__; },
        set: function (h) {
            var _a;
            var c = X(h);
            rt(c) || _this.transform.__translateY__ === c || (_this.transform.__translateY__ = c, C(s, (_a = {}, _a[Dt] = "".concat(c, "px"), _a)));
        }
    }), b(this, j, Lt).call(this), b(this, q, xt).call(this), E(this.transform, {
        scale: r,
        translateX: 0,
        translateY: 0
    }), t.classList.add(qt), this.mounted = !0, this.emit("ready", this);
}, j = new WeakSet(), Lt = function () {
    var _this = this;
    var _a = this, t = _a.wrapper, s = _a.options, n = _a.controller.signal, o = s.draggable, r = s.pinchable, i = s.wheelable;
    if (this.states = {}, i) {
        this.states.wheeling = !1;
        var l = function (h) { return b(_this, k, zt).call(_this, h); };
        t.addEventListener(he, l, { signal: n });
    }
    if (L && (o || r)) {
        o && (this.states.dragging = !1), r && (this.states.pinching = !1);
        var l = function (h) { return b(_this, F, Ct).call(_this, h); };
        t.addEventListener("touchstart", l, { signal: n });
    }
    if (!L && o) {
        this.states.dragging = !1;
        var l = function (h) { return b(_this, G, Mt).call(_this, h); };
        t.addEventListener("mousedown", l, { signal: n });
    }
    b(this, P, It).call(this);
}, k = new WeakSet(), zt = function (t) {
    var _this = this;
    var _a = this.options, s = _a.zoomRatio, n = _a.wheelReleaseOnMinMax, o = _a.disableWheelingClass, r = (t.deltaY || t.detail) > 0 ? -1 : 1;
    if (n) {
        var i = this.isOnMinScale(), l = this.isOnMaxScale();
        i && r === -1 || l && r === 1 || t.preventDefault();
    }
    else
        t.preventDefault();
    this.states.wheeling || ct(t.target, o) || (this.states.wheeling = !0, setTimeout(function () {
        _this.states.wheeling = !1;
    }, 30), this.zoom(r * s, R(t)), this.emit("wheel", this, this.transform.scale, t));
}, G = new WeakSet(), Mt = function (t) {
    var _this = this;
    var _a = this, s = _a.data, n = _a.transform, _b = _a.options, o = _b.disableDraggingClass, r = _b.smooth, i = s.dragData, l = s.imageData;
    if (!i || !l)
        return;
    var h = function (m) {
        if (m && m.button !== 0 || (m.preventDefault(), ct(m.target, o)))
            return;
        i.frame !== null && cancelAnimationFrame(i.frame);
        var a = Date.now(), _a = R(m), d = _a.clientX, g = _a.clientY;
        if (E(i, {
            prevX: d,
            prevY: g,
            lastTime: a,
            velocityX: 0,
            velocityY: 0,
            frame: null
        }), _this.states.dragging = !0, r) {
            var _ = _this.useAnimate(i);
            i.frame = requestAnimationFrame(_);
        }
        _this.emit("dragStart", _this, { x: n.translateX, y: n.translateY }, m), document.addEventListener("mousemove", c), document.addEventListener("mouseup", f);
    }, c = function (m) {
        if (m.touches || !_this.states.dragging)
            return;
        m.preventDefault();
        var a = Date.now(), _a = R(m), d = _a.clientX, g = _a.clientY, _ = d - i.prevX, T = g - i.prevY, u = a - i.lastTime, v = n.translateX + _, O = n.translateY + T;
        _this.moveTo({ x: v, y: O }), r && u > 0 && (i.velocityX = 0.8 * (_ / u) + 0.2 * i.velocityX, i.velocityY = 0.8 * (T / u) + 0.2 * i.velocityY), E(i, {
            prevX: d,
            prevY: g,
            lastTime: a
        }), _this.emit("drag", _this, { x: v, y: O }, m);
    }, f = function (m) {
        m.touches || (_this.states.dragging = !1, _this.emit("dragEnd", _this, { x: n.translateX, y: n.translateY }, m), document.removeEventListener("mousemove", c), document.removeEventListener("mouseup", f));
    };
    h(t);
}, F = new WeakSet(), Ct = function (t) {
    var _this = this;
    var _a = this, s = _a.data, n = _a.transform, _b = _a.options, o = _b.maxScale, r = _b.minScale, i = _b.draggable, l = _b.pinchable, h = _b.bounds, c = _b.dragReleaseOnBounds, f = _b.disableDraggingClass, m = _b.smooth, a = s.touchData, d = s.imageData;
    if (!a || !d)
        return;
    var g = function (u) {
        if (!u.touches)
            return;
        if (h && c) {
            var z = _this.isOnBoundX(), M = _this.isOnBoundY();
            u.touches.length === 1 && (z || M) || u.preventDefault();
        }
        else
            u.preventDefault();
        if (ct(u.target, f) && u.touches.length <= 1)
            return;
        a.frame !== null && cancelAnimationFrame(a.frame);
        var v = Date.now(), _a = y(_this.image), O = _a.top, D = _a.left, _b = _this.getImageDiff(), A = _b.width, et = _b.height, _c = R(u), N = _c.clientX, B = _c.clientY;
        if (E(a, {
            hypot: Et(u),
            prevX: N,
            prevY: B,
            offsetX: 0,
            offsetY: 0,
            imageTop: O,
            imageLeft: D,
            widthDiff: A,
            heightDiff: et,
            lastTime: v,
            velocityX: 0,
            velocityY: 0,
            frame: null
        }), i) {
            if (_this.states.dragging = !0, m) {
                var z = _this.useAnimate(a);
                a.frame = requestAnimationFrame(z);
            }
            _this.emit("dragStart", _this, { x: n.translateX, y: n.translateY }, u);
        }
        l && u.touches.length === 2 && (_this.states.pinching = !0, _this.emit("pinchStart", _this, n.scale, u)), document.addEventListener("touchmove", _), document.addEventListener("touchend", T);
    }, _ = function (u) {
        if (!u.touches)
            return;
        var v = Date.now(), _a = _this.states, O = _a.dragging, D = _a.pinching, _b = y(_this.image), A = _b.top, et = _b.left, _c = _this.getImageDiff(), N = _c.width, B = _c.height, z = D && u.touches.length !== 2 || !D && u.touches.length === 2, M = Et(u), st = M ? M / a.hypot : 1, nt = _this.useFixedRatio(st * n.scale), _d = R(u), it = _d.clientX, ot = _d.clientY, Ht = it + a.offsetX, Zt = ot + a.offsetY;
        if (l && u.touches.length === 2 && (D || (_this.states.pinching = !0, _this.emit("pinchStart", _this, n.scale, u)), _this.zoomTo(nt, !1)), O) {
            z && (a.velocityX = 0, a.velocityY = 0);
            var pt = nt !== o && nt !== r && l && u.touches.length === 2 ? st : 1, Vt = X(Ht - a.imageLeft - (N - a.widthDiff) - (a.prevX - a.imageLeft) * pt + n.translateX), Ut = X(Zt - a.imageTop - (B - a.heightDiff) - (a.prevY - a.imageTop) * pt + n.translateY);
            if (_this.moveTo({ x: Vt, y: Ut }), m && u.touches.length === 1 && !z) {
                var at = v - a.lastTime;
                if (at > 0) {
                    var jt = it - a.prevX, kt = ot - a.prevY;
                    a.velocityX = 0.8 * (jt / at) + 0.2 * a.velocityX, a.velocityY = 0.8 * (kt / at) + 0.2 * a.velocityY;
                }
            }
        }
        E(a, {
            hypot: M,
            prevX: it,
            prevY: ot,
            imageTop: A,
            imageLeft: et,
            widthDiff: N,
            heightDiff: B,
            lastTime: v
        }), D && u.touches.length === 2 && _this.emit("pinch", _this, n.scale, u), O && _this.emit("drag", _this, { x: n.translateX, y: n.translateY }, u);
    }, T = function (u) {
        if (!u.touches)
            return;
        var _a = _this.states, v = _a.dragging, O = _a.pinching;
        if (O && u.touches.length === 1) {
            _this.states.pinching = !1;
            var _b = R(u), D = _b.clientX, A = _b.clientY;
            E(a, {
                prevX: D,
                prevY: A,
                velocityX: 0,
                velocityY: 0,
                lastTime: Date.now()
            }), _this.emit("pinchEnd", _this, n.scale, u);
        }
        if (v && !u.touches.length && (_this.states.dragging = !1, _this.emit("dragEnd", _this, { x: n.translateX, y: n.translateY }, u)), v && u.touches.length === 1) {
            var _c = R(u), D = _c.clientX, A = _c.clientY;
            E(a, {
                offsetX: a.prevX - D,
                offsetY: a.prevY - A
            });
        }
        u.touches.length || (document.removeEventListener("touchmove", _), document.removeEventListener("touchend", T));
    };
    g(t);
}, P = new WeakSet(), It = function () {
    var _this = this;
    var _a = this, t = _a.element, s = _a.image, n = _a.transform;
    new ResizeObserver(function () {
        var r = t.offsetWidth, i = t.offsetHeight, _a = _this.getContainerData(), l = _a.width, h = _a.height;
        if (r === l && i === h)
            return;
        var c = n.translateX, f = n.translateY;
        if (c) {
            var _ = r / l * c;
            _this.transform.translateX = _;
        }
        if (f) {
            var _ = i / h * f;
            _this.transform.translateY = _;
        }
        var m = s.offsetWidth, a = s.offsetHeight, _b = y(s), d = _b.width, g = _b.height;
        E(_this.data.containerData, {
            width: r,
            height: i
        }), E(_this.data.imageData, {
            originWidth: m,
            originHeight: a,
            width: d,
            height: g
        }), _this.emit("resize", _this);
    }).observe(t);
}, q = new WeakSet(), xt = function () {
    var _a = this.__modules__, t = _a.slider, s = _a.zoomer;
    t && b(this, K, $t).call(this), s && b(this, Q, Bt).call(this);
}, K = new WeakSet(), $t = function () {
    var _a = this, t = _a.element, s = _a.__modules__.slider;
    if (!s || s.mounted)
        return;
    var _b = s.options, n = _b.el, o = _b.direction;
    if (!n)
        return;
    var r = n === ".".concat($), i = r ? I("div", $) : lt(n);
    if (!i)
        return;
    var l = I("div", Qt), h = I("span", te), c = I("span", ee, __assign(__assign({}, ie), { "aria-orientation": o }));
    i.classList.add("".concat($, "-").concat(o)), H(s, "value", {
        get: function () {
            return s.__value__;
        },
        set: function (f) {
            var _a;
            s.__value__ !== f && (s.__value__ = f, C(i, (_a = {}, _a[de] = f.toString(), _a)), x(c, { "aria-valuenow": f.toString() }));
        }
    }), E(s, {
        value: this.getScaleRatio() * 100,
        controller: new AbortController(),
        sliding: !1,
        sliderEl: i,
        sliderTrack: l,
        sliderButton: c
    }), b(this, J, Nt).call(this), l.append(h, c), i.append(l), r && t.append(i), s.mounted = !0;
}, J = new WeakSet(), Nt = function () {
    var _this = this;
    var _a = this, _b = _a.options, t = _b.minScale, s = _b.maxScale, n = _a.__modules__.slider;
    if (!n)
        return;
    var o = n.options.direction, r = n.controller, i = n.sliderEl, l = n.sliderTrack;
    if (!i || !l)
        return;
    var h = o === "vertical", c = function (d) {
        var g = y(l), _ = g[h ? "height" : "width"], T = g[h ? "bottom" : "left"], u = R(d)[h ? "clientY" : "clientX"], v = X(w((u - T) * (h ? -1 : 1) / _, 0, 1));
        return (s - t) * v + t;
    }, f = function (d) {
        if (d instanceof MouseEvent && d.button !== 0)
            return;
        n.sliding = !0;
        var g = c(d);
        _this.zoomTo(g), _this.emit("slideStart", _this, _this.getSliderValue(), d), document.addEventListener(Tt, m), document.addEventListener(Ot, a);
    }, m = function (d) {
        if (!n.sliding)
            return;
        var g = c(d);
        _this.zoomTo(g), _this.emit("slide", _this, _this.getSliderValue(), d);
    }, a = function (d) {
        _this.emit("slideEnd", _this, _this.getSliderValue(), d), n.sliding = !1, document.removeEventListener(Tt, m), document.removeEventListener(Ot, a);
    };
    i.addEventListener(ce, f, { signal: r == null ? void 0 : r.signal });
}, Q = new WeakSet(), Bt = function () {
    var _a = this, t = _a.element, s = _a.__modules__.zoomer;
    if (!s || s.mounted)
        return;
    var _b = s.options, n = _b.el, o = _b.inEl, r = _b.outEl, i = _b.resetEl, l = [o, r, i], h = function (d, g, _, T, u) {
        if (!d)
            return null;
        var v = d === ".".concat(_);
        return _ = l.includes(d) ? "".concat(_, " ").concat(se) : _, v ? I(g, _, T, u) : lt(d);
    }, c = h(n, "div", Z), f = h(o, "button", mt, oe, Se), m = h(r, "button", dt, ae, be), a = h(i, "button", ft, re, Te);
    E(s, {
        controller: new AbortController(),
        zoomerEl: c,
        zoomerInEl: f,
        zoomerOutEl: m,
        zoomerResetEl: a
    }), c && (f && c.append(f), m && c.append(m), a && c.append(a), n === ".".concat(Z) && t.append(c)), b(this, tt, Wt).call(this), s.mounted = !0;
}, tt = new WeakSet(), Wt = function () {
    var _a = this, t = _a.options.zoomRatio, s = _a.__modules__.zoomer, n = this;
    if (!s)
        return;
    var o = s.controller, r = s.zoomerInEl, i = s.zoomerOutEl, l = s.zoomerResetEl;
    r && r.addEventListener("click", function () {
        n.zoom(t);
    }, { signal: o == null ? void 0 : o.signal }), i && i.addEventListener("click", function () {
        n.zoom(-t);
    }, { signal: o == null ? void 0 : o.signal }), l && l.addEventListener("click", function () {
        n.reset();
    }, { signal: o == null ? void 0 : o.signal });
};
Object.assign(Ye.prototype, Oe);
export { Ye as default };
